import { IQueryState } from 'services/utils/QueryState';

import {
  SoftwareInstallationItem,
  SoftwarePackageItem,
  SoftwareInventorySummary,
} from 'app/api/services/scanVaultSoftware';

export interface SoftwareInventoryState {
  summary: IQueryState<SoftwareInventorySummary>;
  packages: IQueryState<SoftwarePackageItem[]>;
  packagesNextCursor?: string;
  isLoadingMorePackages: boolean;
  installations: IQueryState<SoftwareInstallationItem[]>;
  // Removed the unused `filter` field.
}

export type ContainerState = SoftwareInventoryState;

export const emptySoftwareInventorySummary: SoftwareInventorySummary = {
  snapshot_mode: '',
  resources_with_software: 0,
  installation_count: 0,
  package_count: 0,
  categories: [],
  ecosystems: [],
  resource_types: [],
};
